import { ref } from 'vue';
import { Category } from '@/entities/category';

export const useCategoryRecord = () => ref<Category>({ title: '' });
